export enum ListWrapperComponentType {
  DIV = "div",
  NAV = "nav",
  UL = "ul",
  OL = "ol"
}

// Needed just for backward compatibility - TODO: remove in next major release
export type ListWrapperComponentStringType = "div" | "nav" | "ul" | "ol";
